import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["submit"]
  static classes = ["disabled"]

  connect() {
    this.updateSubmitState()
    this.registerFieldListeners()
  }

  registerFieldListeners() {
    const requiredFields = this.element.querySelectorAll("[required]")
    requiredFields.forEach(field => {
      field.addEventListener("change", () => this.updateSubmitState())
      field.addEventListener("input", () => this.updateSubmitState())
    })
  }

  updateSubmitState() {
    const isValid = this.allRequiredFieldsFilled()
    this.submitTarget.disabled = !isValid
  }

  allRequiredFieldsFilled() {
    const requiredFields = this.element.querySelectorAll("[required]")
    
    return Array.from(requiredFields).every(field => {
      // Handle checkboxes and radio buttons
      if (field.type === "checkbox" || field.type === "radio") {
        const fieldName = field.name
        return document.querySelector(`input[name="${fieldName}"]:checked`) !== null
      }
      
      // Handle text inputs, textareas, select, etc. (respects minlength, maxlength, pattern)
      return field.checkValidity()
    })
  }
}
